"use client"

import { useState, useEffect } from "react"
import { BestsellersBlock } from "@/components/blocks/bestsellers"
import { RecentViewsBlock } from "@/components/blocks/recent-views"
import { getBestsellers, getRecentlyViewed } from "@/lib/recommendations"

/**
 * Bestsellers and Recently Viewed blocks for blog tag pages.
 * Matches /blogs/news bottom section (same data, same order).
 */
export function TagBottomBlocks() {
  const [bestsellers, setBestsellers] = useState<any[]>([])
  const [recentViews, setRecentViews] = useState<any[]>([])

  useEffect(() => {
    const safe = <T,>(p: Promise<T>, fallback: T) => p.catch(() => fallback)
    Promise.all([
      safe(getBestsellers(6), []),
      safe(getRecentlyViewed(6), []),
    ]).then(([b, r]) => {
      setBestsellers(b)
      setRecentViews(r)
    })
  }, [])

  return (
    <div className="mt-3 space-y-3 px-2 sm:px-0">
      <BestsellersBlock products={bestsellers} />
      <RecentViewsBlock products={recentViews} />
    </div>
  )
}
